export default __webpack_public_path__ + "bc9f901bdc1f8f198397095133217780.png";